import { render, staticRenderFns } from "./campaigns-stats-detailed-table.vue?vue&type=template&id=15843e92&"
import script from "./campaigns-stats-detailed-table.vue?vue&type=script&lang=js&"
export * from "./campaigns-stats-detailed-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports